import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import anime from "animejs";
import "./EndSurvey.css";

const endQuestions = [
  {
    name: "q1",
    text: "Wie einfach war es für Sie, die Web-App zu öffnen?",
    type: "slider",
    options: ["Sehr schwierig", "Schwierig", "Neutral", "Einfach", "Sehr einfach"]
  },
  {
    name: "q2",
    text: "Wie lange haben Sie tatsächlich insgesamt im Wartezimmer gewartet? (in Minuten)",
    type: "text"
  },
  {
    name: "q3",
    text: "Wie haben Sie die tatsächliche Wartezeit empfunden?",
    type: "single",
    options: ["Sehr kurz", "Angemessen", "Etwas zu lang", "Sehr lang"]
  },
  {
    name: "q4",
    text: "Wie entspannt fühlten Sie sich nach der Wartezeit im Wartezimmer?",
    type: "single",
    options: ["Sehr entspannt", "Entspannt", "Neutral", "Gestresst", "Sehr gestresst"]
  },
  {
    name: "q5",
    text: "Wie sehr hat das Memory-Spiel Ihnen geholfen, sich zu entspannen?",
    type: "slider",
    options: ["Überhaupt nicht", "Wenig", "Mittel", "Stark", "Sehr stark"]
  },
  {
    name: "q6",
    text: "Wie oft hatten Sie durch das Spiel das Gefühl, sich von der Wartezeit ablenken zu können?",
    type: "single",
    options: ["Nie", "Fast nie", "Manchmal", "Ziemlich oft", "Sehr oft"]
  },
  {
    name: "q7",
    text: "Hatten Sie das Gefühl, die Wartezeit sinnvoll zu nutzen?",
    type: "single",
    options: ["Ja", "Nein"]
  },
  {
    name: "q8",
    text: "Haben Sie die Memory-Spiel-Web-App während der Wartezeit genutzt?",
    type: "single",
    options: [
      "Ja ",
      "Nein, ich bin direkt zur Endumfrage gesprungen "
    ]
  },
  {
    name: "q9",
    text: "Hat das Memory-Game dazu beigetragen, dass Sie die Wartezeit als kürzer empfunden haben?",
    type: "slider",
    options: ["Länger", "Etwas länger", "Neutral", "Etwas kürzer", "Kürzer"]
  },
  {
    name: "q10",
    text: "Wie zufrieden waren Sie mit dem Memory-Spiel?",
    type: "slider",
    options: ["Sehr unzufrieden", "Unzufrieden", "Neutral", "Zufrieden", "Sehr zufrieden"]
  },
  {
    name: "q11",
    text: "Wie intuitiv war die Verwendung der Memory-Web-App?",
    type: "slider",
    options: ["Sehr intuitiv", "Etwas intuitiv", "Neutral", "Weniger intuitiv", "Garnicht intuitiv"]
  },
  {
    name: "q12",
    text: "Welche Aspekte des Memory-Games haben Ihnen am meisten gefallen? (Mehrfachauswahl möglich)",
    type: "multiple",
    options: [
      "Die spielerische Ablenkung",
      "Die informativen Gesundheitskarten",
      "Die einfache Bedienbarkeit",
      "Der Timer / Fortschrittsanzeige",
      "Die Herausforderung, schneller zu werden",
      "Die Ranglisten-Funktion",
      "Sonstiges"
    ]
  },
  {
    name: "q13",
    text: "Haben Sie die Ranglisten-Funktion genutzt (falls verfügbar)?",
    type: "single",
    options: [
      "Ja, ich fand es spannend, meine Zeit zu vergleichen",
      "Ja, aber es war mir nicht so wichtig",
      "Nein, ich habe sie nicht genutzt",
      "Nicht vorhanden"
    ]
  },
  {
    name: "q14",
    text: "Finden Sie es motivierend, dass eine Bestenliste existiert?",
    type: "slider",
    options: ["Überhaupt nicht", "Wenig", "Mittel", "Stark", "Sehr stark"]
  },
  {
    name: "q15",
    text: "Wie bewerten Sie das Design der Web-App insgesamt? (1 = sehr schlecht, 5 = sehr gut)",
    type: "single",
    options: ["1", "2", "3", "4", "5"]
  },
  {
    name: "q16",
    text: "Welche der folgenden Design-Aspekte haben Ihnen gefallen? (Mehrfachauswahl möglich)",
    type: "multiple",
    options: [
      "Die Farbgestaltung",
      "Die Schriftgröße & Lesbarkeit",
      "Die Animationen & Effekte",
      "Die allgemeine Anordnung der Elemente",
      "Die Klarheit & Übersichtlichkeit der App",
      "Sonstiges"
    ]
  },
  {
    name: "q17",
    text: "Welche der folgenden Design-Aspekte haben Ihnen NICHT gefallen? (Mehrfachauswahl möglich)",
    type: "multiple",
    options: [
      "Die Farbgestaltung",
      "Die Schriftgröße war zu klein/schwer lesbar",
      "Zu wenig oder zu viele Animationen",
      "Das Layout war unübersichtlich",
      "Die App wirkte zu langweilig / wenig motivierend",
      "Alles hat gepasst",
      "Sonstiges"
    ]
  },
  {
    name: "q18",
    text: "Wie bewerten Sie die Nutzerführung & Navigation in der App?",
    type: "single",
    options: [
      "Sehr schlecht, ich wusste nicht, wohin ich klicken muss",
      "Schlecht, es war nicht intuitiv",
      "Neutral, ich habe mich zurechtgefunden",
      "Gut, die Navigation war logisch",
      "Sehr gut, alles war intuitiv und verständlich"
    ]
  },
  {
    name: "q19",
    text: "Was könnte an der Web-App verbessert werden? (Mehrfachauswahl möglich)",
    type: "multiple",
    options: [
      "Mehr Spiel-Varianten neben Memory",
      "Längere oder kürzere Spielzeitoptionen",
      "Anpassbare Schwierigkeitsstufen",
      "Andere Gesundheitsinhalte neben Memory",
      "Besseres Design oder andere Farben",
      "Sonstiges"
    ]
  },
  {
    name: "q20",
    text: "Hatten Sie technische Schwierigkeiten mit der Web-App?",
    type: "slider",
    options: ["Überhaupt nicht", "Kaum", "Neutral", "Ein wenig", "Stark"]
  },
  {
    name: "q21",
    text: "Würden Sie das Memory-Spiel in Zukunft zur Unterhaltung während der Wartezeit nutzen?",
    type: "single",
    options: ["Ja", "Eventuell", "Nein"]
  },
  {
    name: "q22",
    text: "Würden Sie sich wünschen,dass diese Web-App dauerhaft in der Praxis genutzt wird?",
    type: "multiple",
    options: [ "Ja", "Nein"]
  }
];

function EndSurvey() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const username = localStorage.getItem("username");

  useEffect(() => {
    if (!username) {
      setMessage("Benutzername nicht gefunden. Bitte starten Sie die Umfrage erneut.");
      setTimeout(() => navigate("/"), 3000);
    }
  }, [username, navigate]);

  const currentQuestion = endQuestions[currentIndex];

  // Slider-Default-Wert setzen, falls noch nicht vorhanden
  useEffect(() => {
    if (currentQuestion.type === "slider" && answers[currentQuestion.name] === undefined) {
      const defaultValue = Math.ceil(currentQuestion.options.length / 2);
      setAnswers(prev => ({ ...prev, [currentQuestion.name]: defaultValue }));
      console.log(`Default für ${currentQuestion.name} gesetzt auf ${defaultValue}`);
    }
  }, [currentQuestion, answers]);

  const handleSliderChange = (e) => {
    setAnswers({ ...answers, [currentQuestion.name]: Number(e.target.value) });
    console.log(`Slider ${currentQuestion.name} geändert auf ${e.target.value}`);
  };

  const handleOption = (answer) => {
    setAnswers({ ...answers, [currentQuestion.name]: answer });
    console.log(`Antwort für ${currentQuestion.name} gesetzt: ${answer}`);
  };

  const handleMultipleChange = (option) => {
    const currentVals = answers[currentQuestion.name] || [];
    const updatedVals = currentVals.includes(option)
      ? currentVals.filter((v) => v !== option)
      : [...currentVals, option];
    setAnswers({ ...answers, [currentQuestion.name]: updatedVals });
    console.log(`Mehrfachantwort für ${currentQuestion.name} aktualisiert:`, updatedVals);
  };

  const nextQuestion = () => {
    // Validierung und Debugging: Prüfe, ob die Antwort für die aktuelle Frage gesetzt ist.
    if (currentQuestion.type === "slider") {
      if (answers[currentQuestion.name] === undefined) {
        setMessage("Bitte bewegen Sie den Regler, um eine Bewertung abzugeben.");
        console.log(`Fehlende Slider-Antwort bei ${currentQuestion.name}`);
        return;
      }
    } else if (currentQuestion.type === "multiple") {
      if (!answers[currentQuestion.name] || answers[currentQuestion.name].length === 0) {
        setMessage("Bitte wählen Sie mindestens eine Option.");
        console.log(`Fehlende Mehrfachauswahl bei ${currentQuestion.name}`);
        return;
      }
    } else if (currentQuestion.type === "text") {
      if (!answers[currentQuestion.name] || answers[currentQuestion.name].trim() === "") {
        setMessage("Bitte geben Sie eine Antwort ein.");
        console.log(`Fehlende Texteingabe bei ${currentQuestion.name}`);
        return;
      }
    } else {
      if (answers[currentQuestion.name] === undefined) {
        setMessage("Bitte wählen Sie eine Option.");
        console.log(`Fehlende Einzelwahl bei ${currentQuestion.name}`);
        return;
      }
    }
    setMessage("");
    console.log("Aktuelle Antworten:", answers);
    if (currentIndex < endQuestions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      submitEndSurvey();
    }
  };

  const submitEndSurvey = async () => {
    try {
      await axios.post("/api/endsurvey", { username, ...answers });
      setMessage("Vielen Dank für Ihre Rückmeldung!");
      console.log("Endumfrage erfolgreich abgesendet:", { username, ...answers });
    } catch (error) {
      console.error("Fehler beim Absenden der Endumfrage:", error.response ? error.response.data : error.message);
      setMessage("Fehler beim Absenden der Endumfrage.");
    }
  };

  return (
    <div className="endsurvey-container">
      <div className="fixed-header">
        <h1 className="endsurvey-title">Endumfrage</h1>
        <div className="progress-indicator">
          {currentIndex + 1}/{endQuestions.length}
        </div>
        <div className="progress-bar-container">
          <div
            className="progress-bar"
            style={{
              width: `${((currentIndex + 1) / endQuestions.length) * 100}%`
            }}
          ></div>
        </div>
      </div>
      <div className="endsurvey-content">
        <div className="end-question-container">
          <p className="question-text">{currentQuestion.text}</p>
          {currentQuestion.type === "slider" ? (
            <div className="slider-container">
              <input
                type="range"
                min="1"
                max={currentQuestion.options.length}
                step="1"
                value={answers[currentQuestion.name]}
                onChange={handleSliderChange}
              />
              <span className="slider-value">
                {currentQuestion.options[answers[currentQuestion.name] - 1]}
              </span>
            </div>
          ) : currentQuestion.type === "text" ? (
            <div className="text-answer">
              <input
                type="text"
                value={answers[currentQuestion.name] || ""}
                onChange={(e) =>
                  setAnswers({ ...answers, [currentQuestion.name]: e.target.value })
                }
                placeholder="Ihre Antwort"
              />
            </div>
          ) : currentQuestion.type === "multiple" ? (
            <div className="options">
              {currentQuestion.options.map((option, index) => (
                <button
                  key={index}
                  type="button"
                  className="option-button"
                  onClick={() => handleMultipleChange(option)}
                  style={{
                    backgroundColor:
                      answers[currentQuestion.name] &&
                      answers[currentQuestion.name].includes(option)
                        ? "#3B82F6"
                        : "transparent"
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          ) : (
            <div className="options">
              {currentQuestion.options.map((option, index) => (
                <button
                  key={index}
                  type="button"
                  className="option-button"
                  onClick={() => handleOption(option)}
                  style={{
                    backgroundColor:
                      answers[currentQuestion.name] === option
                        ? "#3B82F6"
                        : "transparent"
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          )}
          <div className="navigation">
            <button type="button" className="next-button" onClick={nextQuestion}>
              Weiter
            </button>
          </div>
        </div>
        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
}

export default EndSurvey;